import React, { useContext, useState } from "react";
import DEF from "../../assets/images/DEF.svg";
import { axInst } from "../Service/Service";
import { FilterContext } from "../../context/Filter";
import { useQuery } from "@tanstack/react-query";

// API for DEF Consumption
const getDEFConsumption = async (arnValue, selectedValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}DEFConsumption`,
    { arn: arnValue, terrain: selectedValue }
  );
  return res.data.result;
};

// API for DEF PFD
const getDefPfd = async (arnValue, selectedValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}defPfd`, {
    arn: arnValue,
    terrain: selectedValue,
  });
  return res.data.result;
};

const DEFConsumption = () => {
  const { arn } = useContext(FilterContext);
  const [selectedValue, setSelectedValue] = useState("");

  const { data: defConsumptionData } = useQuery({
    queryKey: ["DEFConsumption", arn, selectedValue],
    queryFn: () => getDEFConsumption(arn, selectedValue),
    enabled: !!arn,
  });
  
  const { data: DefPfdData } = useQuery({
    queryKey: ["defPfd", arn, selectedValue],
    queryFn: () => getDefPfd(arn, selectedValue),
    enabled: !!arn,
  });

  const approxValue = Math.abs(
    ((DefPfdData || 0) - (defConsumptionData || 0)).toFixed(2)
  );

  return (
    <div>
      {/* Header with Filter */}
      <div className="bg-[#2374BF] text-white pr-1 rounded-t-lg flex justify-between items-center">
        <h2 className="text-md p-1 pl-2 font-semibold">DEF Consumption</h2>
        <div className="relative">
          <select
            onChange={(e) => setSelectedValue(e.target.value)}
            value={selectedValue}
            className="block appearance-none bg-[#FFFFFF66] border border-gray-300 py-1 px-4 pr-8 rounded leading-tight focus:outline-none focus:border-gray-300 text-sm text-black"
          >
            <option value="">Select Terrain</option>
            <option value="Plain_Partly_Hilly">Plain Partly Hilly</option>
            <option value="Off_road">Off Road</option>
            <option value="Mixed">Mixed</option>
            <option value="Hilly">Hilly</option>
            <option value="State_HW">State HW</option>
            <option value="NH_Great_1_Lane">NH Great1 Lane</option>
            <option value="Deep_mining">Deep Mining</option>
            <option value="Intracity">Intracity</option>
            <option value="Intercity">Intercity</option>
            <option value="Plain">Plain</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-white">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      {/* DEF Consumption Cards - All in one row */}
      <div className="flex flex-row justify-between py-4 px-2 gap-4">
        {/* Card 1 */}
        <div className="flex flex-col border p-4 rounded-lg shadow-md w-64 h-56 items-center justify-center">
          <img src={DEF} alt="DEF Icon" className="h-24 w-24 mb-2" />
          <div className="text-center">
            <div className="text-2xl font-bold text-[#2374BF]">
              {DefPfdData?.toFixed(2) || "0"} KL
            </div>
            <p className="text-sm text-gray-600 mt-1">
              Purchased From Dealer (8 Parts Nos)
            </p>
          </div>
        </div>

        {/* Card 2 */}
        <div className="flex flex-col border p-4 rounded-lg shadow-md w-64 h-56 items-center justify-center">
          <img src={DEF} alt="DEF Icon" className="h-24 w-24 mb-2" />
          <div className="text-center">
            <div className="text-2xl font-bold text-[#2374BF]">
              {(defConsumptionData || 0).toFixed(2)} KL
            </div>
            <p className="text-sm text-gray-600">Total Consumed</p>
            <p className="text-sm text-white">Total Consumed</p>
          </div>
        </div>

        {/* Card 3 */}
        <div className="flex flex-col border p-4 rounded-lg shadow-md w-64 h-56 items-center justify-center">
          <img src={DEF} alt="DEF Icon" className="h-24 w-24 mb-2" />
          <div className="text-center">
            <div className="text-2xl font-bold text-[#2374BF]">
              {approxValue.toFixed(2)} KL
            </div>
            <p className="text-sm text-gray-600 mt-1">
              Approximate DEF Procured from NON TML
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Note */}
      <div className="px-2 text-sm text-gray-500 text-center">
        * IF Total DEF Consumed = 0 for all terrain is due to no fuel Trail Data
        for PL Available
      </div>
    </div>
  );
};

export default DEFConsumption;
